import { render, staticRenderFns } from "./DynamicButton.vue?vue&type=template&id=6f9f085e"
import script from "./DynamicButton.vue?vue&type=script&lang=js"
export * from "./DynamicButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f9f085e')) {
      api.createRecord('6f9f085e', component.options)
    } else {
      api.reload('6f9f085e', component.options)
    }
    module.hot.accept("./DynamicButton.vue?vue&type=template&id=6f9f085e", function () {
      api.rerender('6f9f085e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DynamicButton.vue"
export default component.exports